import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  key: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user/reset_reminder_delay',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useResetUserReminderDelayLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useResetUserReminderDelayLazy;
